const userTypes = [
  { label: 'Administrador', value: 'ADMINISTRATOR' },
  { label: 'Usuario', value: 'USER' },
];

export default userTypes;
